<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading" @on-cancel="cancel" :width="610">
      <h3 slot="header" class="modal-header">修改组织机构</h3>
      <div>
        <Form :model="formData" :label-width="120"  :rules="formRules" ref="formData"v-if="formData" >
          <FormItem label="所属机构">
            <div>{{formData.parentOrganName}}</div>
            <!--<Input :disabled="true" v-model="projectName" class="item-width" :number="true"></Input>-->
          </FormItem>
          <FormItem label="机构代码" prop="organCode">
            <Input   class="item-width" v-model="formData.organCode" disabled></Input>
          </FormItem>
          <FormItem label="机构名称" prop="organName">
            <Input  class="item-width"  v-model="formData.organName"></Input>
          </FormItem>
          <FormItem label="是否区域" prop="hasShopSelf">
            <Select  class="item-width" placeholder="请选择" v-model="formData.hasShopSelf">
              <Option v-for="item in isShopList" :value="item.value" :key="'keyA'+item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
          <FormItem label="区域" prop="areaFid" v-if="formData.hasShopSelf==1">
            <Select  class="item-width" placeholder="请选择" v-model="formData.areaFid">
              <Option v-for="item in areaList" :value="item.value" :key="'keyA'+item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
          <FormItem label="负责人" prop="leaderUid"  class="ivu-select-not-found-hidden">
            <!--
            <Input  class="item-width" v-model="formData.leaderUid" ></Input>
            -->
            <Select
              class="item-width"
              v-model="formData.leaderUid"
              filterable
              remote
              :remote-method="getUserList"
                    :label="label"
            >
              <Option v-for="(item, index) in userList" :value="item.uid" :key="'keyGG'+index">{{item.nickName}}</Option>
            </Select>
          </FormItem>
        </Form>
      </div>
    </Modal>
  </div>


</template>
<script>
  import {organmodify} from "../../../../api/systemmanage";
  import {deepClone} from "../../../../utils/format";
  import {getUserList} from "../../../../api/user";
  import {projectsByCondition} from "../../../../api/common";
  // import {mapGetters} from "vuex";

  export default {
    name: ""   ,
    components:{
    },
    props:{
      n: {
        type: Number,
        default: 0
      },
      data:{
        type:Object,
        default:null,
        label:''
      }

    },
    computed:{
      // ...mapGetters(['projectListByCondiction'])

    },
    watch:{
      n(){
        this.userList=[]
        this.label=this.data.leaderName
        this.formData=this.formatData(this.data)
        // 查询区域信息
        this.getAreaList()
        this.isShow=true

      }
    },
    data(){
      return {
        userList:[],
        areaList:[],
        formData:null,
        isShopList:[{text:'是',value:'1'},{text:'否',value:'0'}],
        loading: true,
        isShow:false,
        formRules:{
          organCode:[{ required: true, message: ' ' ,trigger: 'blur', type:'string'}],
          organName:[{ required: true, message: ' ' ,trigger: 'blur', type:'string'}],
          hasShopSelf:[{ required: true, message: ' ' ,trigger: 'change', type:'string'}],
          areaFid:[{ required: true, message: ' ' ,trigger: 'change', type:'string'}],
        },
      }
    },
    methods:{
      formatData(){
        let data=deepClone(this.data)
        data['hasShopSelf']=data.hasShop===true?'1':'0'
        return data

      },
      getAreaList(){
        projectsByCondition({
          cityCodes:[]
        }).then(res=>{
          this.areaList = res.data;
        }).catch(error=>{

        })
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok(){
        this.$refs['formData'].validate(bool => {
          if (bool) {
            let params={
              ...this.formData,
              hasShop:this.formData.hasShopSelf==='1'?true:false

            }
            organmodify(params).then(res=>{
              this.$Message.success('组织机构修改成功')
              this.$emit('done')

            }).catch(error=>{

            }).finally(()=>{
              this.isShow=false
            })

          }
          else {
            this.changeLoading()
          }
        })

      },
      cancel(){

      },
      getUserList(value){
        if(!(value+'')){
          this.userList=[]
          return
        }
        let params={
          organUid:this.data.parentOrganId,
          nameOrPhone:value
        }
        getUserList(params).then(res=>{
          //赋值
          if(!res.data){
            return
          }
          this.userList=res.data.rows

        }).catch(error=>{})


      }
    }

  }
</script>

<style scoped>
  .item-width{
    width: 280px;
  }


</style>
